import { apiRoutes } from '../../api-routes';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type { EstimateNewOrderRequestBody } from '../intercity';
import type { IntercityOrderRequest } from '../intercity/types';
import type { PackageDetail } from '../order';
import type { ApiError } from '../types';

export interface EstimateNewOrderResponse {
  service_id: string;
  error?: ApiError;
  data?: EstimateNewOrderData;
  promo_error_message?: string;
}

export type EstimateNewOrderData = {
  distance: number;
  duration: number;
  distance_fee: number;
  stop_fee: number;
  weight_fee: number;
  request_fee: number;
  discount: number;
  total_cod?: number;
  total_fee: number;
  total_pay: number;
  total_price: number;
  vat_fee: number;
  cod_commission_fee: number;
  online_pay: number;
  voucher_discount: number;
  surge_rate: number;
  special_request_price: number;
  subtotal_price: number;
  vat: number;
  distance_price: number;
  stoppoint_price: number;
  weight_price: number;
  cod_commission_price: number;
  total_balance: number;
  payment_method: string;
  partner_id: string;
  promo_error_message?: string;
  currency: string;
  user_main_account: number;
  user_bonus_account: number;
  is_postpaid: boolean;
  is_child_account: boolean;
  partner_fee: number;
  partner_distance_fee: number;
  partner_weight_fee: number;
  partner_stop_fee: number;
  partner_request_fee: number;
  partner_discount: number;
  partner_subsidy: number;
  fee_discrepancy: number;
  partner_pay: number;
  premium_service_fee: number;
  hour_fee: number;
  package_detail: PackageDetail[];
  package_dimensions: PackageDimensions;
  polyline_points: string;
  polylines: string;
  user_price_details: UserPriceDetails;
  discount_details: DiscountDetail[];
  requests: IntercityOrderRequest[];
};

export type PackageDimensions = {
  weight: number;
  length: number;
  width: number;
  height: number;
  billable_weight: number;
  weight_fee_calculation_type: string; // 'by_order' | ...
};

export type UserPriceDetails = {
  total_fee: number;
  details: {
    name: string;
    value: number;
  }[];
};

export type DiscountDetail = {
  is_valid: boolean;
  promo_code_id: string;
  discount_value: number;
  error_message?: string;
};

export const estimateNewOrderFn = async (
  body: EstimateNewOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<EstimateNewOrderResponse[]>(
    apiRoutes.order.estimate,
    body,
    config
  );

  return response.data;
};
